import { Reducer } from 'redux';

import COLLAPSE_LIST from 'constants/collapse';

import { CollapseTypes, CollapseState } from './types';

const INITIAL_STATE: CollapseState = {
  collapseList: [...COLLAPSE_LIST],
};

const reducer: Reducer<CollapseState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // CASES COLLAPSE
    case CollapseTypes.SET_TOGGLE_COLLAPSE:
      return {
        ...state,
        collapseList: action.payload.collapseList,
      };

    default:
      return state;
  }
};

export default reducer;
